
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-white pt-24 pb-16">
      <div className="absolute inset-0 bg-gradient-to-b from-indigo-50/30 to-transparent"></div>
      <div className="container px-4 relative z-10 pt-8 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="flex flex-col items-center text-center lg:col-span-6 lg:items-start lg:text-left">
              <h1 className="mt-6 text-4xl font-bold tracking-tight text-gray-900 opacity-0 animate-slide-up-delayed sm:text-5xl md:text-6xl">
                Simplifiez votre gestion des{" "}
                <span className="text-indigo-600">réseaux sociaux</span>
              </h1>
              <p className="mt-6 text-lg leading-relaxed text-gray-600 opacity-0 animate-slide-up-delayed-2">
                Scaloo transforme votre présence sur les réseaux sociaux en automatisant la création 
                de contenu, la planification et l'analyse de performance avec une technologie IA avancée.
              </p>
              <div className="mt-10 flex w-full flex-col space-y-4 opacity-0 animate-slide-up-delayed-3 sm:flex-row sm:space-x-4 sm:space-y-0">
                <Link to="/register" className="w-full sm:w-auto">
                  <Button className="w-full h-12 rounded-md bg-indigo-600 px-8 text-white transition-all hover:bg-indigo-700 sm:w-auto">
                    Commencer Gratuitement
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
                <Button
                  variant="outline"
                  className="w-full h-12 rounded-md border-gray-300 px-8 text-gray-700 transition-all hover:bg-gray-50 sm:w-auto"
                >
                  Voir la Démo
                </Button>
              </div>
              <div className="mt-10 flex items-center justify-center space-x-6 lg:justify-start">
                <div className="flex -space-x-2">
                  {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="inline-block h-8 w-8 rounded-full border-2 border-white bg-gray-200"></div>
                  ))}
                </div>
                <p className="text-sm text-gray-600">
                  <span className="font-medium">+2,000</span> utilisateurs actifs
                </p>
              </div>
            </div>
            <div className="mt-16 flex items-center lg:col-span-6 lg:mt-0">
              <div className="relative mx-auto w-full max-w-lg lg:max-w-none">
                <div className="relative">
                  <div className="absolute -inset-0.5 rounded-2xl bg-gradient-to-r from-indigo-300 to-indigo-200 opacity-30 blur-xl"></div>
                  <div className="relative overflow-hidden rounded-2xl bg-white shadow-xl">
                    <img
                      src="https://images.unsplash.com/photo-1618761714954-0b8cd0026356?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80"
                      alt="Scaloo Dashboard"
                      className="w-full object-cover"
                    />
                  </div>
                </div>
                <div className="animate-floating absolute -right-10 -top-10 h-40 w-40 rounded-full bg-indigo-100 opacity-30 blur-3xl"></div>
                <div className="animate-floating absolute -bottom-6 -left-6 h-40 w-40 rounded-full bg-indigo-100 opacity-30 blur-3xl"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-20 py-8 bg-gradient-to-b from-white to-indigo-50/30">
        <div className="container px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 gap-8 md:grid-cols-4 lg:grid-cols-5">
            <div className="col-span-2 lg:col-span-1">
              <p className="text-sm font-medium text-gray-500">Ils nous font confiance</p>
            </div>
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="flex items-center justify-center">
                <div className="h-8 w-32 bg-gray-200 rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
